export const formatKRW = new Intl.NumberFormat('ko-KR', {
  style: 'currency',
  currency: 'KRW',
  maximumFractionDigits: 0,
}).format;

export const compactFormatKRW = new Intl.NumberFormat('ko-KR', {
  style: 'currency',
  currency: 'KRW',
  notation: 'compact',
  compactDisplay: 'long',
  maximumFractionDigits: 0,
}).format;

/** 1억 5,000만원 / 500만원 / 900,000원 */
export function formatManwon(amount: number): string {
  if (amount >= 100_000_000) {
    const eok = amount / 100_000_000;
    return `${eok.toFixed(1)}억원`;
  }
  if (amount >= 10_000) {
    const man = Math.round(amount / 10_000);
    return `${man.toLocaleString('ko-KR')}만원`;
  }
  return formatKRW(amount);
}
